import React from "react"
import styled from "styled-components"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import CirclePhone from "../Icons/CirclePhone"
import CircleQuote from "../Icons/CircleQuote"
import EmergencyCtaBg from "../Image/EmergencyCtaBg"
import EsimateCtaBg from "../Image/EsimateCtaBg"
import RequestQuote from "../RequestQuote"
import WhiteOutlineButton from "../Button/WhiteOutlineButton"
import BreakpointUp from "../Media/BreakpointUp"

const Wrap = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  ${BreakpointUp.lg`
		flex-direction:row;
	`}
`
const LeftCTA = styled.div`
  position: relative;
  z-index: 1;
  background: #06488e;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;

  padding-top: 60px;
  padding-bottom: 60px;
  padding-left: 30px;
  padding-right: 30px;
  ${BreakpointUp.xl`
		padding-top:100px;
		padding-bottom:100px;
		`}
  ${BreakpointUp.xxl`
		padding-left: calc(50vw - 675px);
		padding-right: 30px;	
		width: 50vw;
		padding-right: 70px;	
		padding-top:160px;
		padding-bottom:160px;
	`}
`
const RightCTA = styled.div`
  position: relative;
  z-index: 1;

  background: #0059b2;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;

  padding-top: 60px;
  padding-bottom: 60px;
  padding-left: 30px;
  padding-right: 30px;
  ${BreakpointUp.xl`
		padding-top:100px;
		padding-bottom:100px;
	`}
  ${BreakpointUp.xxl`
		padding-right: calc(50vw - 675px);
		padding-left: 30px;	
		width: 50vw;
		padding-left: 70px;	
		padding-top:160px;
		padding-bottom:160px;
	`}
`

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  text-align: center;
  margin: 0 -10px;
  ${BreakpointUp.sm`
		text-align: left;
	`}
`

const GridCol = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;

  ${BreakpointUp.sm`			
		flex-basis: 0;    
		flex-grow: 1;
		max-width: 100%;
	`}
  & strong {
    display: block;
    position: relative;
    z-index: 2;
    font-family: 'UniNeueBold', sans-serif;
    font-weight: 800;
    color: #fff;
    max-width: 305px;
    width: 100%;
    font-size: 18px;
    line-height: 26px;
    margin: 0 auto 15px;
    ${BreakpointUp.sm`
			margin-bottom:0;
		`}
    ${BreakpointUp.md`
			font-size: 22px;
			line-height: 32px;
		`}
		${BreakpointUp.xxl`
			font-size: 24px;
			line-height: 34px;
		`}
  }
`
const GridAuto = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
  ${BreakpointUp.sm`			
		flex: 0 0 auto;
		width: auto;
		max-width: 100%;
		text-align: right;
	`}
  & .btn {
    padding: 9px 20px;
    .text {
      white-space: nowrap;
    }
    .icon {
      > svg {
        width: 30px;
      }
    }
    ${BreakpointUp.xxl`			
    		padding: 19px 30px;
			.icon {
				> svg {			
					width: 36px;
				}
			}
		`}
  }
`
const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.15;
  .gatsby-image-wrapper {
    height: 100%;
    width: 100%;
  }
`

class EmergencyEstimateCTA extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpenRequest: false,
    }
    this.openRequestQuote = this.openRequestQuote.bind(this)
    this.closeRequestQuote = this.closeRequestQuote.bind(this)
  }
  openRequestQuote() {
    this.setState({
      isOpenRequest: true,
    })
    //document.body.style.height = "100vh"
    document.querySelector("body").classList.add("modal-open")
  }
  closeRequestQuote() {
    this.setState({
      isOpenRequest: false,
    })
    //document.body.style.height = "unset"
    document.querySelector("body").classList.remove("modal-open")
  }


  render() {
    const { leftData, rightData } = this.props
    const { isOpenRequest } = this.state
    if (leftData != null && rightData != null) {
      return (
        <Wrap>
          <RequestQuote
            display={isOpenRequest ? "block" : "none"}
            onClose={this.closeRequestQuote}
          />
          <LeftCTA>
            <Background>
              <GatsbyImage image={getImage(leftData.image)} alt="AES" />
            </Background>
            <Grid>
              <GridCol>
                <strong>{leftData.title}</strong>
              </GridCol>
              <GridAuto>
                <a href="tel:8663861001">
                  <WhiteOutlineButton
                    textAfter={leftData.linkText}
                    icon={<CirclePhone />}
                  />
                </a>
              </GridAuto>
            </Grid>
          </LeftCTA>
          <RightCTA>
            <Background>
              <GatsbyImage image={getImage(rightData.image)} alt="AES" />
            </Background>
            <Grid>
              <GridCol>
                <strong>{rightData.title}</strong>
              </GridCol>
              <GridAuto>
                <button onClick={this.openRequestQuote}>
                  <WhiteOutlineButton
                    textAfter={rightData.linkText}
                    icon={<CircleQuote />}
                  />
                </button>
              </GridAuto>
            </Grid>
          </RightCTA>
        </Wrap>
      )
    } else {
      return (
        <Wrap>
          <RequestQuote
            display={isOpenRequest ? "block" : "none"}
            onClose={this.closeRequestQuote}
          />
          <LeftCTA>
            <Background>
              <EmergencyCtaBg />
            </Background>
            <Grid>
              <GridCol>
                <strong>Need Emergency Repairs?<br />Call Us Now!</strong>
              </GridCol>
              <GridAuto>
                <a href="tel:8663861001">
                  <WhiteOutlineButton
                    textAfter="866-386-1001"
                    icon={<CirclePhone />}
                  />
                </a>
              </GridAuto>
            </Grid>
          </LeftCTA>
          <RightCTA>
            <Background>
              <EsimateCtaBg />
            </Background>
            <Grid>
              <GridCol>
                <strong>Estimate Your Repair Cost!<br />Request a Quote!</strong>
              </GridCol>
              <GridAuto>
                <button onClick={this.openRequestQuote}>
                  <WhiteOutlineButton
                    textAfter="Request a Quote!"
                    icon={<CircleQuote />}
                  />
                </button>
              </GridAuto>
            </Grid>
          </RightCTA>
        </Wrap>
      )
    }
  }
}

export default EmergencyEstimateCTA
